import { Crypto } from "../../../models/Crypto.ts";
import canonicalize from "canonicalize";
import { HB } from "../../global.ts";

// is humanity required = need to login + create passkey!
// also want aqua ai to access it

// context = step 1 + step 2
// locker: all done locally
export class Locker {
    private crypto = new Crypto();

    // encrypt and sign
    async mint(state: any): Promise<Object> {
        const data: any = { b: {}, l: {}, f: {}, n: {} };
        // optional: d: {}, t: [], g: {}

        // pro no: j: {}, x: {} // x=a (anchor)
        // prob don't need to sign jewel:coverart or x bc:
        // can update anytime after minting without needing passkey

        const isPrivate = state.location.e || state.media.e || state.message.e;
        const isPublic =
            !state.location.e || !state.media.e || !state.message.e; // not used
        const isEncrypted = isPrivate || state.isHumanityRequired;

        // encrypt message
        let symmetricKey: CryptoKey | null = null,
            encryptedData: string | null = null,
            iv: string | null = null;
        if (isEncrypted) {
            if (state.sk && state.iv) {
                symmetricKey = await this.crypto.getSKFromSession(state.sk);
                iv = state.iv;
                encryptedData = await this.crypto.encryptMessage2(
                    symmetricKey!,
                    iv!,
                    state.message.m
                );
            } else {
                ({ symmetricKey, encryptedData, iv } =
                    await this.crypto.encryptMessage(state.message.m));
            }
        }

        // check-in location
        data.l.i = state.location.i; // id // google place id // TODO: later use org id
        data.l.r = state.location.r; // locality, region
        data.l.c = state.location.c; // country
        data.l.n = state.location.n; // place name
        data.l.y = state.location.y; // place lat
        data.l.x = state.location.x; // place lng
        data.l.k = state.location.k === "crew" ? 0 : 1; // kind: "crew" | "org"
        data.l.a = state.location.a; // address
        data.l.t = state.location.t; // lat
        data.l.g = state.location.g; // lng
        if (state.location.e) data.l.e = 1; // is private
        if (state.location.e || state.isHumanityRequired) {
            data.l.h = await this.crypto.hash(canonicalize(data.l)!); // hash for buyer to verify
            data.l.a = await this.crypto.encryptMessage2(
                symmetricKey!,
                iv!,
                data.l.a
            );
            data.l.t = await this.crypto.encryptMessage2(
                symmetricKey!,
                iv!,
                data.l.t.toString()
            );
            data.l.g = await this.crypto.encryptMessage2(
                symmetricKey!,
                iv!,
                data.l.g.toString()
            );
        }

        // diamonds: media upload, gem, url
        if (state.media.m.length > 0) {
            data.d = state.media; // encrypted on the client
            if (state.media.e || state.isHumanityRequired)
                data.d.h = state.media.m.length; // to know if encrypted
        }

        // silver: note or message
        data.n.d = Date.now(); // date in milliseconds //new Date().getTime() // for local chests
        data.n.m = state.message.m; // silver: plaintext message
        if (state.message.e) data.n.e = 1; // is private
        if (state.message.e || state.isHumanityRequired) {
            data.n.h = await this.crypto.hash(data.n.m); // hash for buyer to verify
            data.n.m = encryptedData; // encrypted message
        }
        if (state.message.v) data.n.v = state.message.v;

        // gratuity
        if (state.gratuity.a > 0) {
            data.g = state.gratuity;
        }

        // to: recipients can always view encrypted location, diamonds, message
        if (state.toRecipients.length > 0) {
            data.t = await Promise.all(
                state.toRecipients.map(async (recipient: any) => {
                    const to: any = {};
                    to.p = recipient.kid; // public key
                    //to.t = 0; // type: 0=locker,1=safe // TODO: v2
                    to.n = 1; // nearby TODO:
                    if (isPrivate)
                        to.k = await this.crypto.encryptKey(
                            to.p,
                            symmetricKey!
                        ); // encrypted symmetric key
                    return to;
                })
            );
        }

        // from
        const content = this.getContent(data);
        data.f.p = await this.crypto.getPublicKeyString(state.fromKey); // public key
        //data.f.t = 0; // type: 0=locker,1=safe // TODO: v2
        //data.f.h = await this.crypto.hash(content); // sha hash
        data.f.s = await this.crypto.sign(state.fromKey, content); // signature
        if (isPrivate) {
            data.f.k = await this.crypto.encryptKey(data.f.p, symmetricKey!); // encrypted symmetric key
        }
        // testing only
        // const {
        //     encryptedSymmetricKey,
        //     encryptedData: encryptedcontent,
        //     iv: iv2
        // } = await this.crypto.encrypt(data.f.p, state.message.m);

        // heartbank
        if (state.timelock) data.b.t = state.timelock;
        data.b.w = this.countWords(state.message.m); // karat // temp for now // TODO: later move to message to get signed
        data.b.d = state.media.m.length; // carat // temp for now // TODO: later move to diamond to get signed
        data.b.c = "v"; // product category: vault silver
        data.b.v =
            state.storage === "cloud" ? 0 : state.storage === "code" ? 1 : 2; // storage // 0 = cloud, 1 = code, 2 = crystal
        if (state.isHumanityRequired) {
            data.b.p = HB.vault; // public key
            data.b.e = 1; // 0 or 1 // for humans only
            data.b.i = iv;
            data.b.k = await this.crypto.encryptKey(data.b.p, symmetricKey!);
        } else if (isEncrypted) {
            data.b.i = iv;
        }

        // testing only
        if (state.message.m !== "") {
            console.log(data);
            this.fromDecrypt(data);
            this.toDecrypt(data);
            //console.warn(this.deepEqual(data, JSON.parse(canonicalize(data)!)));
        }

        return data;
    }

    // both locker and safe
    store(data: any, message: string) {
        // after minting
        // data.j = {}; // jewel: cover art // do in step 3
        // data.x = {}; // x marks the spot or a for anchor // do in step 4
        window.localStorage.setItem(
            "treasure",
            encodeURIComponent(canonicalize(data)!)
        );
        window.localStorage.setItem("silver", message); //plaintext
    }

    // signature: n + l + d + t + g
    private getContent(data: any) {
        const content: any = { n: data.n, l: data.l };
        if (data.d) content.d = data.d;
        if (data.t) content.t = data.t;
        if (data.g) content.g = data.g;
        return canonicalize(content)!;
    }

    // both locker and safe
    async verifyFrom(data: any) {
        return await this.crypto.verify(
            data.f.p,
            this.getContent(data),
            data.f.s
        );
    }

    // safe
    async verifyHumanity(data: any) {
        return await this.crypto.verify(data.b.p, data.f.s, data.b.s);
    }

    // for testing

    private async fromDecrypt(data: any) {
        // verify signature
        const isVerified = await this.verifyFrom(data);
        console.log("Verifying Signature: ", isVerified);

        // decrypt
        if (data.n.h && data.f.k) {
            const encryptedPackage = {
                encryptedSymmetricKey: data.f.k,
                encryptedData: data.n.m,
                iv: data.b.i
            };
            const plaintext = await this.crypto.decrypt(
                data.f.p,
                encryptedPackage
            );
            console.log("From Decrypted Silver: ", plaintext);
        }
    }

    private async toDecrypt(data: any) {
        if (data.t) {
            const recipient = data.t[0];
            if (recipient.k) {
                const encryptedPackage = {
                    encryptedSymmetricKey: recipient.k,
                    encryptedData: data.n.m,
                    iv: data.b.i
                };
                const plaintext = await this.crypto.decrypt(
                    recipient.p,
                    encryptedPackage
                );
                console.log(
                    "To Decrypted Silver: ",
                    plaintext || "Recipient not found"
                );
            }
        }
    }

    private deepEqual(a: any, b: any): boolean {
        // Strict equality covers primitives and reference equality
        if (a === b) return true;

        // Handle null and undefined
        if (a == null || b == null) return a === b;

        // Handle Date objects
        if (a instanceof Date && b instanceof Date)
            return a.getTime() === b.getTime();

        // Handle Array or Object
        if (typeof a !== "object" || typeof b !== "object") return false;

        const keysA = Object.keys(a);
        const keysB = Object.keys(b);

        if (keysA.length !== keysB.length) return false;

        // Compare keys recursively
        for (const key of keysA) {
            if (!keysB.includes(key)) return false;
            if (!this.deepEqual(a[key], b[key])) return false;
        }

        return true;
    }

    // International
    private countWords(str: string): number {
        const matches = str.match(/\p{L}+\p{M}*/gu);
        return matches ? matches.length : 0;
    }
}
